import { casinoStoreKeys } from '../casinoStoreConstants'
import { useSetCasinoData } from '../hooks'

export const useSetCasinoLobbyBanners = () => {
  const { setCasinoData } = useSetCasinoData()

  const setCasinoLobbyBanners = casinoLobbyBanners => {
    if (casinoLobbyBanners && Array.isArray(casinoLobbyBanners) && casinoLobbyBanners.length > 0) {
      setCasinoData({ [casinoStoreKeys.casinoLobbyBanners]: casinoLobbyBanners }, 'setCasinoLobbyBanners')
    }
  }
  return { setCasinoLobbyBanners }
}
